import React, { useEffect, useState, useRef } from "react";
import ReactDOM from "react-dom";
import { useDropzone } from "react-dropzone";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { maxFileSize } from "../../../utils/constant";
import { modalEventListener } from "../../../utils/ModalEventListener";
import { axios_instance } from "../../../api/axios_instance";
import { downloadExcelFunction } from "../../../utils/helperFunctions";
import ModalWrapper from "../../../layouts/ModalWrapper";
import LoadingModal from "../../../layouts/LoadingModal";

const BulkUploadModal = ({
  closeBulkUploadModal,
  openConfirmationModal,
  showBulkUploadModal,
}) => {
  const [state, setState] = useState({ files: [] });
  const [showLoadingModal, setShowLoadingModal] = useState(false);
  const ref = useRef();

  useEffect(() => {
    return modalEventListener(ref, handleCloseModal);
  }, [closeBulkUploadModal]);

  useEffect(() => {
    if (state.files.length > 0) toast(<Message />);
  }, [state.files]);

  const onDrop = (f) => {
    setState({ ...state, files: [f[0]] });
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: { "text/csv": [".csv", ".xls", ".xlsx"] },
    maxFiles: 1,
    maxSize: maxFileSize,
    multiple: false,
  });

  const getNames = () => {
    return state.files[0] ? state.files[0].name : "";
  };

  const Message = () => (
    <>
      <span className="glyphicon glyphicon-ok-sign"></span>
      {` ${getNames()}`} has been uploaded, to complete process click on
      "Complete Upload".
    </>
  );
  const handleCloseModal = () => {
    setState({ files: [] }); // Reset files state to empty array
    closeBulkUploadModal(); // Call the original close modal function
  };

  const downloadFormatFile = async () => {
    try {
      const resp = await axios_instance({
        url: "/bulkbank/fetchCSVData",
        method: "GET",
        headers: {
          "Content-Type": "multipart/form-data",
        },
        responseType: "blob",
      });
      if (resp.status === 200) {
        downloadExcelFunction(resp.data, "bulk_payment_example");
      }
    } catch (error) {}
  };

  const uploadBulkPayment = async () => {
    toast.dismiss();
    if (!state.files.length) {
      return toast.error("Please upload file to complete process.", {
        theme: "colored",
      });
    }
    setShowLoadingModal(true);
    try {
      const data = new FormData();
      data.append("file", state.files[0]);

      const result = await axios_instance({
        url: "/bulkbank/bulkCaseUpload",
        method: "POST",
        data,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (result.status === 200) {
        if (result.data.errorCount) {
          const sheetResult = await axios_instance({
            url: "/bulkbank/fetchErrorSheet",
            method: "POST",
            data: {
              sheet: result.data.sheet,
              errorFileName: result.data.errorFileName,
            },
            responseType: "blob",
          });
          return downloadExcelFunction(
            sheetResult.data,
            result.data.errorFileName
          );
        }
        const confirmationData = result.data.confirmationData;
        openConfirmationModal(confirmationData, "", "bulk_case_upload");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message, { theme: "colored" });
    } finally {
      setShowLoadingModal(false);
      handleCloseModal();
    }
  };

  return ReactDOM.createPortal(
    <ModalWrapper show={showBulkUploadModal} onClose={handleCloseModal}>
      {showLoadingModal && <LoadingModal />}
      <div className="modal-wrapper">
        <ToastContainer
          closeOnClick={false}
          draggable={false}
          closeButton={false}
        />
        <div className="bulkupload-modal-content" ref={ref}>
          <div className="modal-header">
            <button type="button" className="close" onClick={handleCloseModal}>
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 className="modal-title" id="">
              Bulk Bank Payment Upload
            </h4>
          </div>
          <div className="modal-body clearfix doc-upload-wrapper">
            <div className="form-group clearfix">
              <div className="row">
                <div className="col-md-5 ">
                  <label className="fnt14">Download input format</label>
                </div>
                <div className="col-md-6">
                  <button
                    type="button"
                    className="btn btn-primary"
                    id="btn-download-format"
                    title="Download Format"
                    onClick={downloadFormatFile}
                  >
                    <span className="fa fa-download"></span> Download Format
                  </button>
                </div>
              </div>
            </div>

            <div className="form-group clearfix">
              <div className="row">
                <div className="col-md-5 ">
                  <label className="fnt14">
                    Accepted Format :{" "}
                    <span className="col-red">.xls, .xlsx</span>
                  </label>
                </div>
                <div className="col-md-12">
                  <div>
                    <form
                      className="dropzone dd-zone"
                      style={{ minHeight: "180px" }}
                      id="bankpayment_document_uploader"
                    >
                      <input
                        type="hidden"
                        name="action"
                        value="upload_bulkpayment_document"
                      />
                      <input type="hidden" name="bank_id" value="" />
                      <input type="hidden" name="dealer_id" value="" />
                      <div
                        className="dz-default dz-message"
                        {...getRootProps()}
                      >
                        <input {...getInputProps()} />
                        Drop files here to upload
                      </div>
                    </form>
                    <div className="clearfix btn-upload-wrapper">
                      <div className="ufn-wrapr">
                        <p className="ufn" id="caseFileUploadDiv">
                          {(() => {
                            const names = getNames();
                            return names.length > 0 ? (
                              <>
                                <span className="fa fa-file-excel-o"></span>
                                {` ${names}`}
                              </>
                            ) : (
                              ""
                            );
                          })()}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer text-center">
            <button
              type="button"
              className="btn rc-btn_primary btn-lg"
              id="completeUploadBtn"
              onClick={uploadBulkPayment}
            >
              Complete Upload
            </button>
          </div>
        </div>
      </div>
    </ModalWrapper>,
    document.querySelector(".myPortalModalDiv")
  );
};

export default BulkUploadModal;
